import React from 'react';
import { BaseActions } from 'src/v2/modules/layout';

export const EmptyHeader: React.FC = () => (
  <BaseActions>
    <span />
  </BaseActions>
);
